import styled from 'styled-components';

export const ContainerDiscountTextAdvancedPayment = styled.div`
  margin-top: 16px;

  .textoInformativoDesconto {
    font-size: 12px;
    line-height: 18px;
  }

  .valorSemAntecipacao {
    color: ${({ tema }) => tema?.accent};
    font-weight: bold;
  }

  .valorAntecipado {
    color: ${({ tema }) => tema?.primaryColor};
    font-weight: bold;
  }
`;
